import $ from 'jquery';

import column from './column/column'

export default function(o,row){

  var click = function(){
    if(o.highlightedRow){
      o.highlightedRow.css({
        border: '',
      })
    }
    o.highlightedRow = div
    o.highlightedRow.css({
      border: '2px solid ' + o.colors.red,
    })
    row.click()
  }

  var columns = row.columns

  var div =
    $('<div>')
    .css({
      height: '34px',
      display: 'table-row',
      cursor: 'pointer',
    })
    .append(
      _.compact(
        _.map(
          columns,
          function(data){
            return column(o,data)
          },
        )
      )
    )
    .hover(
      function(e){
        $(this).css({background: 'rgba(255,255,255,.10)'})
      },
      function(e){
        $(this).css({background: ''})
      },
    )
    .click(click)

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/search/table/rows/row/row.js